import { useEffect, useState } from 'react';
import { adminGet, adminPut } from '../adminApi';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Card, Field, Sel, GREEN } from './bfsiShared';

export default function BfsiSetupTab({ tenantId }) {
  const [prof, setProf] = useState(null);
  const [dep, setDep] = useState(null);

  useEffect(() => {
    adminGet(`/customers/${tenantId}/bfsi-profile`).then(setProf).catch(e => toast.error(e.message));
    adminGet(`/customers/${tenantId}/deployment`).then(setDep).catch(e => toast.error(e.message));
  }, [tenantId]);

  const saveProf = async () => {
    try { setProf(await adminPut(`/customers/${tenantId}/bfsi-profile`, prof)); toast.success('Entity profile saved'); }
    catch (e) { toast.error(e.message); }
  };
  const saveDep = async () => {
    try { setDep(await adminPut(`/customers/${tenantId}/deployment`, dep)); toast.success('Deployment saved'); }
    catch (e) { toast.error(e.message); }
  };

  if (!prof || !dep) return <div className="text-sm" style={{ color: '#9a9e96' }}>Loading…</div>;
  const p = (k) => (v) => setProf({ ...prof, [k]: v });
  const d = (k) => (v) => setDep({ ...dep, [k]: v });

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-testid="bfsi-setup-tab">
      <Card>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold" style={{ color: '#1B1D1C' }}>Regulated entity</h3>
          <span className="text-xs px-2 py-1 rounded-full font-medium" style={{ background: '#E3F1EC', color: GREEN }}>
            Tier: {prof.compliance_tier} · locked
          </span>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <Sel label="Entity type" value={prof.entity_type} onChange={p('entity_type')} testId="bfsi-entity-type"
            options={[['BANK', 'Bank'], ['NBFC', 'NBFC'], ['FINTECH', 'Fintech'], ['CASH_LOGISTICS', 'Cash logistics']]} />
          <Sel label="Use case" value={prof.use_case} onChange={p('use_case')} testId="bfsi-use-case"
            options={[['GOLD_LOAN_PICKUP', 'Gold loan doorstep pickup (lockbox)'], ['CASH_IN_TRANSIT', 'Cash-in-transit van'], ['VAULT', 'Branch vault / strong room']]} />
          <Field label="RBI registration / CoR no." value={prof.rbi_registration_no} onChange={p('rbi_registration_no')} testId="bfsi-rbi-no" />
          <Sel label="Due-diligence questionnaire" value={prof.due_diligence_status} onChange={p('due_diligence_status')} testId="bfsi-dd-status"
            options={[['NOT_STARTED', 'Not started'], ['RECEIVED', 'Received'], ['IN_PROGRESS', 'In progress'], ['SUBMITTED', 'Submitted'], ['APPROVED', 'Approved']]} />
          <Field label="CISO / infosec contact" value={prof.ciso_contact} onChange={p('ciso_contact')} testId="bfsi-ciso-contact" />
          <Field label="Vendor-risk contact" value={prof.vendor_risk_contact} onChange={p('vendor_risk_contact')} testId="bfsi-vendor-risk-contact" />
          <Sel label="Contract (audit rights, exit)" value={prof.contract_status} onChange={p('contract_status')} testId="bfsi-contract-status"
            options={[['PENDING', 'Pending'], ['SIGNED', 'Signed']]} />
          {prof.contract_signed_on && (
            <div className="text-sm self-end pb-2" style={{ color: '#6b7069' }}>
              Signed on {new Date(prof.contract_signed_on).toLocaleDateString()}
            </div>
          )}
        </div>
        <Button data-testid="bfsi-save-profile-btn" onClick={saveProf} className="mt-5 text-white" style={{ background: GREEN }}>
          Save entity profile
        </Button>
      </Card>

      <Card>
        <h3 className="font-bold mb-4" style={{ color: '#1B1D1C' }}>Where will their data live?</h3>
        <div className="grid grid-cols-2 gap-4">
          <Sel label="Deployment" value={dep.deployment_tier} onChange={d('deployment_tier')} testId="bfsi-deployment-tier"
            options={[['SHARED_SAAS', 'Shared SaaS'], ['DEDICATED_SAAS', 'Dedicated SaaS'], ['CUSTOMER_CLOUD', 'Customer cloud'], ['ON_PREMISE', 'On-premise']]}
            disabledOptions={['SHARED_SAAS']} />
          <Sel label="Environment" value={dep.environment_status} onChange={d('environment_status')} testId="bfsi-env-status"
            options={[['PLANNED', 'Planned'], ['BEING_SET_UP', 'Being set up'], ['LIVE', 'Live']]} />
          <Field label="Region" value={dep.region} onChange={d('region')} testId="bfsi-region" placeholder="ap-south-1" />
          <Field label="Customer AWS account ID" value={dep.aws_account_id} onChange={d('aws_account_id')} testId="bfsi-aws-account" />
          <Field label="Device server (MQTT) domain" value={dep.mqtt_domain} onChange={d('mqtt_domain')} testId="bfsi-mqtt-domain" placeholder="mqtt.customer.trackotic.in" />
          <Field label="Location encryption key (KMS ARN)" value={dep.kms_key_arn} onChange={d('kms_key_arn')} testId="bfsi-kms-arn" />
        </div>
        <p className="text-xs mt-3" style={{ color: '#9a9e96' }}>
          This domain must be added to the M2M SIM whitelist for every device sent to this customer.
          Changing these records does not create infrastructure.
        </p>
        <Button data-testid="bfsi-save-deployment-btn" onClick={saveDep} className="mt-4 text-white" style={{ background: GREEN }}>
          Save deployment
        </Button>
      </Card>
    </div>
  );
}
